import React, { useState } from 'react';

import { ChevronSortIcon } from '@vlabs/icons';
import type { FilterFormValues } from '@vlabs/monokit/entities/matcher/types/types';
import { Control, Dropdown, DropdownItem } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';

import { useSearch } from '@vlabs/pages/search/ui/search-provider/SearchProvider';

import { useSearchPageTranslation } from '../../../i18n';

function SortFilter(): React.JSX.Element {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { t } = useSearchPageTranslation();
  const { setValue, handleSubmit } = useFormContext<FilterFormValues>();

  const { setSearchResults, search } = useSearch();
  const order = useWatch({ name: 'order' });

  const closeDropdown = () => setIsDropdownOpen(false);
  const toggleDropdown = () => setIsDropdownOpen((p) => !p);

  const onSubmit = (values: FilterFormValues) => {
    setSearchResults(undefined);
    search(values);
  };

  const handleSort = (nextOrder: string) => {
    closeDropdown();

    setValue('order', nextOrder);
    handleSubmit(onSubmit)();
  };

  return (
    <Dropdown
      isOpen={isDropdownOpen}
      onClose={closeDropdown}
      options={[
        <DropdownItem
          key="similarity"
          label={t('results.sort_button.label', { context: 'similarity' })}
          onClick={() => handleSort('similarity')}
          selected={order === 'similarity'}
        />,
        <DropdownItem
          key="create_time_desc"
          label={t('results.sort_button.label', { context: 'create_time_desc' })}
          onClick={() => handleSort('create_time_desc')}
          selected={order === 'create_time_desc'}
        />,
        <DropdownItem
          key="create_time_asc"
          label={t('results.sort_button.label', { context: 'create_time_asc' })}
          onClick={() => handleSort('create_time_asc')}
          selected={order === 'create_time_asc'}
        />,
      ]}
    >
      <Control.Button
        icon={<ChevronSortIcon />}
        kind="secondary"
        onClick={toggleDropdown}
        size="small"
      >
        {t('results.sort_button.label', { context: order })}
      </Control.Button>
    </Dropdown>
  );
}

export { SortFilter };
